<template>
    <div>
        <section class="about-us section-padding pb-26-until-sm">
            <div class="container">
                <div class="text-left">
                    <div class="mt-60">
                        <hr>
                        <h4 class="hZUCZe fs-25px">{{ $t('Custom Systems and Digital Strategies for Business Success') }}</h4>
                        <p class="mb-30 text-p-sans mt-60">{{ $t('At JLHSOFT TECHNOLOGY we develop customized technological systems and comprehensive digital strategies designed to optimize the performance and maximize the growth of your company. Our approach combines technological innovation and digital marketing to offer unique solutions that improve processes, increase productivity and connect your brand with the right audience.') }}</p>
                        <h4 class="hZUCZe fs-25px">{{ $t('Unparalleled security') }}</h4>
                        <p class="mb-10 text-p-sans mt-25">{{ $t('In a constantly evolving digital world, the protection of your data is our priority. We implement the most advanced security solutions to guarantee the integrity of your information, preventing cyber threats and ensuring the peace of your business. With our robust security strategies, your company will be protected against digital risks, allowing you to operate with confidence and efficiency in the online environment.') }}</p>
                        <ButtonReadmore />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import ButtonReadmore  from '@/components/ButtonReadmore.vue'
export default{
    name: "SectionBComponent",
    components: {
        ButtonReadmore
    },
   
}
</script>
<style scoped>

</style>